module.exports = __webpack_public_path__ + "img/right-eye.36b47410.svg";